import * as React from "react";
import { IconProps } from "./IconProps";

export const IconMap = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="map, paper">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.3895 2.2925C14.5633 2.4178 14.6663 2.61904 14.6663 2.83333V11.5C14.6663 11.787 14.4827 12.0417 14.2105 12.1325L10.2105 13.4658C10.0736 13.5114 9.9257 13.5114 9.78886 13.4658L5.99967 12.2027L2.21049 13.4658C2.00719 13.5336 1.78371 13.4995 1.60987 13.3742C1.43602 13.2489 1.33301 13.0476 1.33301 12.8333V4.16667C1.33301 3.87971 1.51663 3.62495 1.78886 3.53421L5.78886 2.20088C5.9257 2.15526 6.07365 2.15526 6.21049 2.20088L9.99967 3.46394L13.7889 2.20088C13.9922 2.13311 14.2156 2.1672 14.3895 2.2925ZM9.33301 4.64717L6.66634 3.75828V11.0195L9.33301 11.9084V4.64717ZM10.6663 11.9084L13.333 11.0195V3.75828L10.6663 4.64717V11.9084ZM5.33301 11.0195V3.75828L2.66634 4.64717V11.9084L5.33301 11.0195Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
